import React from "react";

function IllustrationRdcListingCompleteness() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 96">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.861 12.671a1.75 1.75 0 0 1 2.278 0l34 29.143c.388.333.611.818.611 1.329V82A1.75 1.75 0 0 1 98 83.75H30A1.75 1.75 0 0 1 28.25 82V43.143c0-.511.223-.996.611-1.329l34-29.143ZM31.75 43.948V80.25h64.5V43.948L64 16.305 31.75 43.948Z"
        className="fill-secondary"
      />
      <path
        d="M59.206 68.704 80.251 47.5l-5.103-5.103-15.942 16.101-5.103-5.103L49 58.498s7.654 7.495 10.206 10.206Z"
        className="fill-primary"
      />
    </svg>
  );
}

export default IllustrationRdcListingCompleteness;
